import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IBaseSearchRequest, IPagedResults } from 'src/app/core/models/base';
import { environment } from 'src/environments/environment';
import { IEmployeeRole, IEmployeeRoleRequest } from '../../employee/employee-roles';

@Injectable({
  providedIn: 'root'
})
export class EmployeeRoleService {

  constructor(private http: HttpClient) { }

  listEmployeeRoleRoles(request: IBaseSearchRequest){
    return this.http.post<IPagedResults<IEmployeeRole[]>>(
      `${environment.baseUrl}/v1/employeeroles/searchemployeeroles`,
      request
    )
  }

  addEmployeeRoleRole(request : IEmployeeRoleRequest){
    return this.http.post<IEmployeeRole>(
      `${environment.baseUrl}/v1/employeeroles/createemployeerole`,
      request
    )
  }

  updateEmployeeRoleRole(request : IEmployeeRole){
    return this.http.put<IEmployeeRole>(
      `${environment.baseUrl}/v1/employeeroles/updateemployeerole/${request.id}`,
      request
    )
  }

  deleteEmployeeRoleRole(id :string){
    return this.http.delete(
      `${environment.baseUrl}/v1/employeeroles/deleteemployeerole/${id}`
    )
  }
}
